export default "__VITE_ASSET__CmWMqqrR__"